// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { OnlineCourse } from '../../types/Model';
import { actionCreatorsList, RootAction } from '../rootActionCreator';

export interface OnlineCourseInformationState {
  onlineCourses: Record<number, OnlineCourse>;
  isLoading: boolean;
  isInformationFetching: boolean;
  isProgressing: boolean;
  isEnding: boolean;
  error?: Error;
}

const { getOnlineCourseDataActions } = actionCreatorsList;

export const initialState: OnlineCourseInformationState = {
  onlineCourses: {},
  isLoading: true,
  isInformationFetching: false,
  isProgressing: false,
  isEnding: false,
};

const onlineCourseDataReducer = (state = initialState, action: RootAction): OnlineCourseInformationState => {
  switch (action.type) {
    case getType(getOnlineCourseDataActions.request): {
      return {
        ...state,
        isLoading: !action.payload.preventLoading,
        error: undefined
      };
    }
    case getType(getOnlineCourseDataActions.success): {
      const { payload } = action;
      const onlineCourse = payload.onlineCourseData;
      return {
        ...state,
        isLoading: false,
        onlineCourses: {
          ...state.onlineCourses,
          [onlineCourse.id]: onlineCourse
        },
      };
    }
    case getType(getOnlineCourseDataActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
}

export { onlineCourseDataReducer as default};
